import { useCallback, useState, type JSX } from 'react';
import { DoubleColumnProductGrid, ProductCard } from '@/components/ui';
import type { Product } from '@/types/Product.types';
import {
  PADDING_BETWEEN,
  PADDING_BOTTOM,
  VIEW_MORE_BUTTON_TEXT,
} from './StaticLoadDoubleColumnProductList.constants';
import styles from './StaticLoadDoubleColumnProductList.module.css';
import type { StaticLoadDoubleColumnProductListProps } from './StaticLoadDoubleColumnProductList.types';

const StaticLoadDoubleColumnProductList = ({
  products,
  showAll = false,
  displayInitially,
  displayOnLoadMore,
}: StaticLoadDoubleColumnProductListProps): JSX.Element => {
  const [displayCount, setDisplayCount] = useState<number>(
    showAll ? products.length : Math.min(products.length, displayInitially)
  );

  const renderProductItem = useCallback((product: Product): JSX.Element => {
    return <ProductCard key={product.id} product={product} />;
  }, []);

  const handleViewMore = (): void => {
    setDisplayCount((prev) =>
      Math.min(products.length, prev + displayOnLoadMore)
    );
  };

  return (
    <>
      <DoubleColumnProductGrid
        products={products.slice(0, displayCount)}
        renderProductItem={renderProductItem}
        paddingBetween={PADDING_BETWEEN}
        paddingBottom={PADDING_BOTTOM}
      />
      {!showAll && displayCount < products.length && (
        <div className={styles.viewMoreButton} onClick={handleViewMore}>
          {VIEW_MORE_BUTTON_TEXT}
        </div>
      )}
    </>
  );
};

export default StaticLoadDoubleColumnProductList;
